import { SponsorResponseType, SponsorsResponseType, Sponsor } from './types';

export type ReshapedSponsors = {
    [key: number]: Sponsor;
};

type SponsorInSession = number;

type RemapSponsor = (sponsor: SponsorResponseType) => Sponsor;

const transformSponsorFields: RemapSponsor = sponsor => ({
    companyName: sponsor['company-name'].toString(),
    id: sponsor.id,
    logoSet: sponsor['logo-set'],
    websiteUrl: sponsor['website-url'],
});

const ensureArray = (sponsorsResponse?: SponsorResponseType | SponsorResponseType[]) => {
    if (Array.isArray(sponsorsResponse)) {
        return sponsorsResponse;
    }
    if (sponsorsResponse?.['company-name']) {
        return [sponsorsResponse];
    }
    return [];
};

export const reshapeSponsorsToObj = (sponsorsResponse: SponsorsResponseType): ReshapedSponsors => {
    const sponsors = sponsorsResponse?.['event-partners']?.sponsors;

    return ensureArray(sponsors).reduce((sponsorsObjs, sponsor) => {
        sponsorsObjs[sponsor.id] = transformSponsorFields(sponsor);
        return sponsorsObjs;
    }, {});
};

/*
    When we deleted all sponsors from event and had had some sponsors in session before deleting, we received
    sponsors on the session after deleting, because of cached server response.
    Hence we need to handle undefined sponsor
*/

export const mapSponsorsById = (
    sponsors: SponsorInSession[],
    reshapedSponsors: ReshapedSponsors
): Sponsor[] =>
    sponsors.reduce((list, id) => {
        const sponsor = reshapedSponsors[id];
        if (!sponsor) {
            return list;
        }
        return [...list, sponsor];
    }, []);
